import { KeyValue } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PluginManagerService } from '../../../service/plugin-manager.service';
import { FourDInjector } from '../../FourDInjector';

@Component({
  selector: 'plugin-ui',
  templateUrl: './plugin-ui.component.html'
})
export class PluginUiComponent implements OnInit, OnChanges, OnDestroy {

  @Input()
  plugin:any = null;

  @Input()
  item:any = null;

  @Input()
  context:any = null;

  @Input() 
  onRemove: (args: any) => void;

  reference:any = null;

  groups:any = {};
  groupCounter:number = 1;
  currentGroup:any = null;

  translate:any = null;

  lastMouseEvent:any = null;

  currentTab:string = 'main';

  constructor( public pluginManager: PluginManagerService ) { 
    this.translate = FourDInjector.injector.get(TranslateService);
  }

  ngOnChanges() { }

  ngOnInit() {
    // console.log('UI-comp', this.plugin, this.item, this.context );
    // console.log('UI-comp controls', this.plugin.controls );
  }

  ngOnDestroy() {
    this.reference = null;
    this.plugin = null;
    this.context = null;
    this.item = null;
  }

  mouseclicks(event:any = null ) {
    this.lastMouseEvent = event;
    // console.log('clickety',event);
  }

  deletePlugin() {

    if ( !this.context ) {
      return;
    }
    
    let pluginId = this.plugin.id;
    let item = this.plugin.item;

    if ( this.plugin.controller ) {
      // console.log('delete ctrl',this.plugin.controller);
      this.plugin.controller.delete ( pluginId, item );
    } else if ( this.context && this.context.deletePlugin ) {
      // console.log('delete context',this.context);
      this.context.deletePlugin ( pluginId, item );
    }

    if ( this.plugin ) {
      this.plugin = null;
    }

  }

  checkGroups( ctrl:any ) {
    let key = ctrl.key;
    let ctrls = ctrl.value;
    let group = ctrls['group'] ? ctrls.group : null;
    if ( group ) {
      if ( ! this.groups[group] ) {
        this.groups[group] = { idx:this.groupCounter++, first: key, last: null, show:false };
      }
      this.currentGroup = group;
      return true; 
    }
    return false;
  }

  getGroupIndex ( ctrl:any ) {
    let ctrls = ctrl.value;
    let group = ctrls['group'] ? ctrls.group : null;
    if ( this.groups[group] ) {
      return this.groups[group].idx;
    }
    return null;
  }

  isFirstInGroup ( ctrl:any ) {
    let key = ctrl.key;
    let ctrls = ctrl.value;
    let group = ctrls['group'] ? ctrls.group : null;
    if ( this.groups[group] && this.groups[group].first == key ) {
      return true;
    }
    return false;
  }

  isFirstNongroup ( ctrl:any ) {
    let ctrls = ctrl.value;
    let group = ctrls['group'] ? ctrls.group : null;
    if ( ! group && this.currentGroup ) {
      this.currentGroup = null;
      return true;
    }
    return false;
  }

  // Preserve original property order
  originalOrder = (a: KeyValue<number,string>, b: KeyValue<number,string>): number => {
    return 0;
  }

  // Order by ascending property value
  valueAscOrder = (a: KeyValue<number,string>, b: KeyValue<number,string>): number => {
    return a.value.localeCompare(b.value);
  }

  // Order by descending property key
  keyDescOrder = (a: KeyValue<number,string>, b: KeyValue<number,string>): number => {
    return a.key > b.key ? -1 : (b.key > a.key ? 1 : 0);
  }

  getReference ( refId:string ) {
    if ( this.plugin && refId && this.plugin.controls && this.plugin.controls[refId] ) {
      this.reference = this.plugin.controls[refId];
      return true;
    }
    return false;
  }

}
